module.exports = __webpack_public_path__ + "img/title3@2x.bf1d248a.png";